<script>
export default {
  name: 'PaginationBar',
  props: {
    pagination: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pageSizeOptions: {
      type: Array,
      default: () => [5, 10, 20, 50],
    },
  },
  methods: {
    handlePreviousPage() {
      if (this.pagination.currentPage > 1) this.$emit('previous');
    },
    handleNextPage() {
      if (this.pagination.currentPage < this.pagination.totalPages) this.$emit('next');
    },
    handlePageSizeChange(newSize) {
      this.$emit('page-size-change', newSize);
    },
  },
};
</script>

<template>
  <div class="flex flex-col sm:flex-row items-center justify-between my-4 gap-3">
    <!-- Page Size Selector -->
    <div class="flex items-center space-x-2">
      <label
        for="page-size-select"
        class="text-sm font-medium text-slate-700 dark:text-slate-300"
      >
        Show
      </label>

      <select
        id="page-size-select"
        :value="pagination.pageSize"
        @change="handlePageSizeChange(parseInt($event.target.value))"
        class="reset-base m-0"
      >
        <option
          v-for="size in pageSizeOptions"
          :key="size"
          :value="size"
        >
          {{ $t('BRANCHES.INDEX.PAGINATION.PER_PAGE', { count: size }) }}
        </option>
      </select>
    </div>

    <!-- Pagination Controls -->
    <div class="flex items-center space-x-2">
      <!-- Prev -->
      <woot-button
        variant="smooth"
        color-scheme="secondary"
        size="small"
        :disabled="pagination.currentPage === 1 || loading"
        aria-label="Previous page"
        @click="handlePreviousPage"
        icon="chevron-left"
      />

      <!-- Page Indicator -->
      <div class="hidden md:flex items-center space-x-1">
        <button
          class="w-8 h-8 flex items-center justify-center rounded-md text-sm font-medium 
                 transition-colors bg-woot-500 text-white"
          aria-current="page"
        >
          {{ pagination.currentPage }}
        </button>
        <span v-if="pagination.totalPages" class="text-sm text-slate-600 dark:text-slate-300">
          / {{ pagination.totalPages }}
        </span>
      </div>

      <!-- Next -->
      <woot-button
        variant="smooth"
        color-scheme="secondary"
        size="small"
        :disabled="pagination.currentPage === pagination.totalPages || loading"
        aria-label="Next page"
        @click="handleNextPage"
        icon="chevron-right"
      />
    </div>
  </div>
</template>
